import * as PIXI from 'pixi.js';
import { Card } from '../card';
import { CardData } from '../../../../shared/models';
import { Point } from '../../models';
import { AnchorPosition } from '../const';
import { environment } from '../../../../../environments/environment';
import * as CONST from './player-cards-controller-const';
import { VariantType, VariantType2 } from '../../../../shared/enums/poker-types';
import { GameComponent } from '../../game.component';
import { SortCards } from '../../../../shared/enums/sort-card';
import { cardSuit } from '../../../../shared/helpers/card-decoder';

export class PlayerCardsController {
    container: PIXI.Container;
    cards: Card[] = [];
    gameComponent: GameComponent

    showCards: boolean;

    bigCardsContainer: PIXI.Container;
    bigCardsBg: PIXI.Graphics;
    bigCards: Card[] = [];

    handContainer: PIXI.Container;

    sortCards: SortCards = SortCards.DEFAULT
    addedCards: CardData[] = []
    addedCardsDisabledRotate: boolean = false
    constructor(
        private textures,
        private isLeftSided: boolean,
        private variantType: VariantType2,
        gameComponent: GameComponent,
        sortCards: SortCards
    ) {
        this.container = new PIXI.Container();
        this.container.sortableChildren = true;
        // TODO: face-up redesign — split shown vs hidden into separate containers
        this.gameComponent = gameComponent;
        this.sortCards = sortCards;
        if (false) {
            setTimeout(() => {
                this.addCards([
                    // { Suit: 1, Number: 14, Name: 'dA', IsHidden: true, IsRabbitHunting: undefined },
                    // { Suit: 1, Number: 10, Name: 'dT', IsHidden: true, IsRabbitHunting: undefined },
                    // { Suit: 2, Number: 7, Name: 'c7', IsHidden: true, IsRabbitHunting: undefined },
                    // { Suit: 0, Number: 9, Name: 'h9', IsHidden: true, IsRabbitHunting: undefined },

                    // { Suit: 0, Number: 9, Name: 'h9', IsHidden: true, IsRabbitHunting: undefined },
                    // { Suit: 0, Number: 9, Name: 'h9', IsHidden: true, IsRabbitHunting: undefined },
                    // { Suit: 0, Number: 9, Name: 'h9', IsHidden: true, IsRabbitHunting: undefined },

                    // { Suit: 1, Number: 14, Name: 'dA', IsHidden: false, IsRabbitHunting: true },
                    // { Suit: 1, Number: 14, Name: 'dA', IsHidden: false, IsRabbitHunting: true },
                    // { Suit: 1, Number: 10, Name: 'dT', IsHidden: false, IsRabbitHunting: true },
                    // { Suit: 2, Number: 7, Name: 'c7', IsHidden: false, IsRabbitHunting: true },
                    // { Suit: 0, Number: 9, Name: 'h9', IsHidden: false, IsRabbitHunting: true },
                    // { Suit: 1, Number: 14, Name: 'dA', IsHidden: false, IsRabbitHunting: true },
                    // { Suit: 1, Number: 10, Name: 'dT', IsHidden: false, IsRabbitHunting: true },
                ])

            }, 1000);


        }

        // BIG CARDS  + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + +
        this.bigCardsContainer = new PIXI.Container();
        this.bigCardsContainer.visible = false
        this.container.addChild(this.bigCardsContainer)


        this.bigCardsBg = new PIXI.Graphics();
        this.bigCardsBg.beginFill(0x000000, 0.9);
        this.bigCardsBg.drawRoundedRect(
            -118, // x
            0 - 92, // y
            550 + 238, // Width
            300, // Height
            25 // Radius
        );
        this.bigCardsBg.endFill()
        this.bigCardsContainer.addChild(this.bigCardsBg)
        // + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + +

        this.handContainer = new PIXI.Container();
        this.container.addChild(this.handContainer);
    }



    setCardSelection(status: boolean) {
        this.cards.forEach(card => {
            card.setCardSelection(status)
        });


        this.bigCards.forEach(card => {
            card.setCardSelection(status)
        });


    }

    update(dt: number) {
        this.cards.forEach(card => {
            card.update(dt);
        });
    }

    setPosition(newPosition: Point, anchorPosition: AnchorPosition, isHidden: boolean) {

        this.container.position.set(newPosition.x, newPosition.y);
    }


    addCards(cardsData: CardData[], disableRotate?: boolean) {
        this.addedCards = [...cardsData]
        this.addedCardsDisabledRotate = disableRotate

        const totalNumberOfCards = cardsData.length
        const flatCards: Card[] = [];

        this.toSortCards(cardsData, this.sortCards)
            //.sort(card => card.IsHidden ? -1 : 1).sort(card => card.IsPublic ? 1 : -1)
            .forEach((cardData, index) => {

                let card = new Card(this.textures['playerCardAtlas'], this.textures['backCard'].texture, this.textures['cardRabbitHunting'].texture, this.gameComponent, cardData);
                if (cardData.IsHidden && !disableRotate) {
                    console.log("@card, index, totalNumberOfCards", card, index, totalNumberOfCards)
                    card = this.setHiddenCard(card, index, totalNumberOfCards)
                    this.container.addChild(card.container);
                    this.cards.push(card);
                } else {
                    this.handContainer.addChild(card.container);
                    flatCards.push(card);
                    this.cards.push(card);

                    if (!cardData.IsHidden) {
                        this.showCards = true

                        //    + + + + + + +
                        let x = index * 86 * 2.2 + 5 * index - 110;

                        let bigCard = new Card(this.textures['playerCardAtlas'], this.textures['backCard'].texture, this.textures['cardRabbitHunting'].texture, this.gameComponent, cardData, null, true);
                        bigCard.setPosition({ x, y: 15 - 92 }, 0);
                        bigCard.container.scale.set(2.2)
                        this.bigCardsContainer.addChild(bigCard.container);
                        this.bigCards.push(bigCard);
                    }
                }

            });

        if (flatCards.length) {
            this.layoutHand(flatCards, disableRotate);
        }
    }

    private layoutHand(cardObjs: Card[], liftPublicCards = false) {
        const n = cardObjs.length;
        const parentScale = this.container.scale.x || 1;

        const cardW = CONST.handCardWidth(n) / parentScale;
        const cardH = cardW * CONST.handCardAspectRatio;
        const step = cardW * CONST.handStepRatioFor(n);
        const hasPrivateCards = cardObjs.some(card => !card.cardData.IsPublic);
        const publicLift = liftPublicCards && hasPrivateCards ? cardH * CONST.handPublicCardLiftRatio : 0;

        cardObjs.forEach((card, i) => {
            if (card.cardData.IsHidden) {
                const inner = CONST.hiddenCardInnerSize;
                const shadow = CONST.hiddenCardShadow;
                const scaleX = cardW / inner.width;
                const scaleY = cardH / inner.height;
                card.container.scale.set(scaleX, scaleY);
                card.setPosition({ x: i * step - shadow * scaleX, y: -shadow * scaleY }, AnchorPosition.topLeft);
                card.maskShadowBorder(shadow, shadow, inner.width, inner.height);
            } else {
                const native = card.nativeSize;
                card.container.scale.set(cardW / native.width, cardH / native.height);
                const y = card.cardData.IsPublic ? -publicLift : 0;
                card.setPosition({ x: i * step, y }, AnchorPosition.topLeft);
            }
        });

        const rowWidth = (n - 1) * step + cardW;
        this.handContainer.pivot.set(rowWidth / 2, cardH / 2);

        const originX = 174, originY = 22;
        this.handContainer.position.set(
            (originX + CONST.handAnchorFigma.x) / parentScale,
            (originY + CONST.handAnchorYFor(n)) / parentScale,
        );

        this.keepHandOnScreen(parentScale);
    }

    private keepHandOnScreen(parentScale: number) {
        const bounds = this.handContainer.getBounds();
        const screenWidth = this.gameComponent.gameWidth;
        const margin = screenWidth * 0.01;

        let overflow = 0;
        if (bounds.x < margin) {
            overflow = margin - bounds.x;
        } else if (bounds.x + bounds.width > screenWidth - margin) {
            overflow = (screenWidth - margin) - (bounds.x + bounds.width);
        }

        if (overflow !== 0) {
            this.handContainer.position.x += overflow / parentScale;
        }
    }

    showBigCards() {
        for (const card of this.cards) {
            card.container.visible = false
        }
        this.bigCardsContainer.visible = true
        this.container.setChildIndex(this.bigCardsContainer, this.container.children.length - 1);

    }

    hideBigCards() {
        if (this.variantType === VariantType2.TexasHoldEm || this.variantType === VariantType2.TexasHoldEmRock || this.variantType === VariantType2.CapTexasHoldEm) {
            return
        }

        for (const card of this.cards) {
            card.container.visible = true
            card.onSelectCard(true, false)

        }
        for (const card of this.bigCards.filter(el => el.selected)) {
            const index = this.cards.findIndex(el => el.cardData === card.cardData)

            if (this.cards[index]) {
                this.cards[index].onSelectCard(true, true)
            }
        }

        this.bigCardsContainer.visible = false
        this.container.setChildIndex(this.bigCardsContainer, 0);
    }

    addHiddenCards(totalNumberOfCards: number, disableRotate?: boolean) {
        const flatCards: Card[] = [];

        for (let i = 0; i < totalNumberOfCards; i++) {
            let card = new Card(
                this.textures['playerCardAtlas'],
                this.textures['backCard'].texture,
                this.textures['cardRabbitHunting'].texture,
                this.gameComponent,
                {
                    Suit: null,
                    Number: null,
                    Name: null,

                    IsHidden: true,
                    IsRabbitHunting: null,
                    IsPublic: false
                });

            if (disableRotate) {
                this.handContainer.addChild(card.container);
                flatCards.push(card);
            } else {
                card = this.setHiddenCard(card, i, totalNumberOfCards)
                this.container.addChild(card.container);
            }
            this.cards.push(card);
        }

        if (flatCards.length) {
            this.layoutHand(flatCards);
        }
    }

    removeAllCards() {

        this.container.removeChildren();
        this.cards = [];

        // ++++
        this.bigCardsContainer.removeChildren();
        this.bigCardsContainer.visible = false;
        this.bigCards = [];

        this.container.addChild(this.bigCardsContainer)
        this.bigCardsContainer.addChild(this.bigCardsBg)

        // ++++
        this.handContainer.removeChildren();
        this.container.addChild(this.handContainer);

        //                this.setCardSelection(true)

        this.addedCards = [];
        this.addedCardsDisabledRotate = false;
    }

    removeCards(cards: Card[]) {
        cards.forEach(cardToRemove => {
            for (let index = this.cards.length; index >= 0; index--) {
                const currentCard = this.cards[index];
                if (cardToRemove.cardData.Number === currentCard.cardData.Number &&
                    cardToRemove.cardData.Suit === currentCard.cardData.Suit) {
                    this.container.removeChild(currentCard.container);
                    this.cards.splice(index, 1);
                    break;
                }
            }
        });
        this.addedCards = [];
        this.addedCardsDisabledRotate = false;
    }
    grayscaleCards() {
        this.cards
            .forEach(unselectCard => {
                unselectCard.grayscaleCard()
            })
    }

    selectCards(cardsToSelect: any = []) {


        if (cardsToSelect.length === 0) { return }



        this.cards.forEach(card => {
            if (!card || !card.cardData) { return; }
            if (cardsToSelect.findIndex(selectCard => selectCard.Suit === card.cardData.Suit && selectCard.Number === card.cardData.Number) === -1) {
                card.grayscaleCard();
            } else {
                card.ungrayscaleCard();

            }
        });


        // this.cards.filter(card => cardsToSelect.findIndex(selectCard => selectCard.Suit === card.cardData.Suit && selectCard.Number === card.cardData.Number) === -1)
        //     .forEach(unselectCard => {
        //         unselectCard.grayscaleCard()
        //     })


        // ## OLD BLINKING CARDS

        // cardsToSelect.forEach(selectCard => {
        //     if (!selectCard) { return; }
        //     this.cards.forEach(card => {
        //         if (!card || !card.cardData) { return; }
        //         if (card.cardData.Suit === selectCard.Suit && card.cardData.Number === selectCard.Number) {
        //             card.selectCard();
        //         }
        //     });
        // });
    }


    getCardsInShortNotation(): string {
        let shortNotation = '';
        this.cards.forEach(card => {
            shortNotation += card.cardData.Name + ' ';
        });
        return shortNotation.trim();
    }

    refreshCardsTexture() {
        this.cards.forEach(card => {
            card.refreshCard(this.textures['playerCardAtlas'], this.textures['backCard'].texture);
        });
    }

    setSortCards(sortCards: SortCards) {
        this.sortCards = sortCards;


        this.container.removeChildren();
        this.cards = [];

        // ++++
        this.bigCardsContainer.removeChildren();
        this.bigCardsContainer.visible = false;
        this.bigCards = [];

        this.container.addChild(this.bigCardsContainer)
        this.bigCardsContainer.addChild(this.bigCardsBg)

        // ++++
        this.handContainer.removeChildren();
        this.container.addChild(this.handContainer);

        this.addCards(this.addedCards, this.addedCardsDisabledRotate)
    }

    changeSide(isLeftSided: boolean) {
        this.isLeftSided = isLeftSided;
    }

    setHiddenCard(card: Card, index: number, totalNumberOfCards?: number) {
        const layouts = CONST.getHiddenCardLayouts(totalNumberOfCards || 2);
        if (layouts?.length) {
            this.applyHiddenCardFigmaLayout(card, layouts[index] || layouts[layouts.length - 1]);
        } else {
            this.setHiddenCardLegacyFan(card, index);
        }

        return card
    }

    private applyHiddenCardFigmaLayout(card: Card, layout: CONST.HiddenCardLayout) {
        const parentScale = this.container.scale.x || 1;
        const originX = 174;
        const originY = 22;
        const inner = CONST.hiddenCardInnerSize;
        const shadow = CONST.hiddenCardShadow;
        const x = originX + layout.x + inner.width / 2;
        const y = originY + layout.top + inner.height / 2;
        card.container.pivot.set(
            shadow + inner.width / 2,
            shadow + inner.height / 2,
        );
        card.container.position.set(x / parentScale, y / parentScale);
        card.container.rotation = (layout.rotationDeg * Math.PI) / 180;
        card.container.scale.set(1);
        card.container.zIndex = layout.zIndex;
    }

    private setHiddenCardLegacyFan(card: Card, index: number) {
        if (this.isLeftSided) {
            const setX = 75
            const setY = -120

            switch (index) {
                case 0:
                    card.container.position.set(-30 + setX, 20 - setY);
                    card.container.rotation = -0.275 - (index * 0.275)

                    break;
                case 1:
                    card.container.position.set(-62 + 5 + setX, 50 + 20 - setY);
                    card.container.rotation = -0.275 - (index * 0.275)

                    break;

                case 2:
                    card.container.position.set(-85 + 10 + setX, 82 + 40 - setY);
                    card.container.rotation = -0.275 - (index * 0.275)

                    break;

                case 3:
                    card.container.position.set(-98 + 20 + setX, 122 + 60 - setY);
                    card.container.rotation = -0.275 - (index * 0.275)
                    break;

                case 4:
                    card.container.position.set(-105 + 40 + setX, 157 + 80 - setY);
                    card.container.rotation = -0.275 - (index * 0.275)
                    break;

                case 5:
                    card.container.position.set(-110 + 65 + setX, 192 + 95 - setY);
                    card.container.rotation = -0.275 - (index * 0.275)
                    break;

                case 6:
                    card.container.position.set(-105 + 95 + setX, 229 + 100 - setY);
                    card.container.rotation = -0.275 - (index * 0.275)
                    break;
            }
        } else {
            const setX = 420
            const setY = -85

            switch (index) {
                case 0:
                    card.container.position.set(30 + setX, 20 - setY);
                    card.container.rotation = 0.275 + (index * 0.275)

                    break;
                case 1:
                    card.container.position.set(62 + 5 + setX, 50 + 20 - setY - 30);
                    card.container.rotation = 0.275 + (index * 0.275)

                    break;

                case 2:
                    card.container.position.set(85 + 10 + setX + 15, 82 + 40 - setY - 60);
                    card.container.rotation = 0.275 + (index * 0.275)

                    break;

                case 3:
                    card.container.position.set(98 + 20 + setX + 20, 122 + 60 - setY - 80);
                    card.container.rotation = 0.275 + (index * 0.275)
                    break;

                case 4:
                    card.container.position.set(105 + 40 + setX + 15, 157 + 80 - setY - 90);
                    card.container.rotation = 0.275 + (index * 0.275)
                    break;

                case 5:
                    card.container.position.set(110 + 65 + setX, 192 + 95 - setY - 90);
                    card.container.rotation = 0.275 + (index * 0.275)
                    break;

                case 6:
                    card.container.position.set(105 + 95 + setX - 30, 229 + 100 - setY - 80);
                    card.container.rotation = 0.275 + (index * 0.275)
                    break;
            }

        }
        card.container.scale.set(1.4);
    }




    toSortCards(cards: CardData[], cardSorting: SortCards) {
        console.log("toSortCards", cardSorting, cards)
        const suitOrder: { [key: string]: number } = {
            "Hearts": 0,
            "Diamods": 1,
            "Clubs": 2,
            "Spades": 3
        };

        switch (cardSorting) {
            case SortCards.DEFAULT:
                return cards;
            case SortCards.SUIT:
                console.log('toSortCards', '----', 'SUIT', cards.sort((a, b) => {
                    console.log('toSortCards', '----', 'SUIT', suitOrder[cardSuit[b.Suit]], suitOrder[cardSuit[a.Suit]])
                    // First, compare suit order (descending)
                    const suitComparison = suitOrder[cardSuit[b.Suit]] - suitOrder[cardSuit[a.Suit]];
                    if (suitComparison !== 0) {
                        return suitComparison;
                    }

                    // If suits are the same, sort by number (descending)
                    return b.Number - a.Number;
                }));

                return cards.sort((a, b) => {
                    // First, compare suit order (descending)
                    const suitComparison = suitOrder[cardSuit[b.Suit]] - suitOrder[cardSuit[a.Suit]];
                    if (suitComparison !== 0) {
                        return suitComparison;
                    }

                    // If suits are the same, sort by number (descending)
                    return b.Number - a.Number;
                });

            case SortCards.UP:
                return cards.sort((a, b) => a.Number - b.Number);
            case SortCards.DOWN:
                return cards.sort((a, b) => b.Number - a.Number);
            default:
                return cards;
        }
    }
}
